// Central SEO configuration. Canonical domain is the production site so the
// preview mirror never competes for the brand entity in search.
export const SITE_URL = "https://coppervine.io";
export const ORG_NAME = "Copper & Vine";
export const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_65e2883a-2f23-4b7a-a146-5637389bf63a/artifacts/ovuys0av_Copper%26VineBW.jpg";

// Per-page titles (<=60 chars) + meta descriptions (~155 chars): one benefit
// sentence plus the primary keyword, written to earn the click.
export const PAGE_SEO = {
  home: {
    title: "Copper & Vine — Executive Technology Advisory",
    description:
      "Executive technology advisory and full-stack engineering since 2003. Product strategy, AI readiness, fractional CTO, and engineering for founders, enterprises, and the public sector.",
    path: "/",
  },
  work: {
    title: "Technology & AI Case Studies — Copper & Vine",
    description:
      "Selected technology consulting case studies: concept to MVP, AI readiness, and funder-ready builds for founders, enterprises, and public agencies.",
    path: "/work",
  },
  services: {
    title: "Fractional CTO, AI Readiness & Engineering — Copper & Vine",
    description:
      "One ladder of engagements: Sprints, fractional CTO and CIO, AI readiness, and full-stack engineering. Start where the exposure is greatest.",
    path: "/services",
  },
  publicSector: {
    title: "Public Sector Technology Advisory — Copper & Vine",
    description:
      "Government AI consulting and public sector technology advisory. Municipal innovation, workforce programs, and AI readiness. Women- and minority-owned, procurement-ready.",
    path: "/public-sector",
  },
  scorecard: {
    title: "Free AI & Technology Readiness Scorecard — Copper & Vine",
    description:
      "A free AI readiness assessment. Score where you stand across strategy, data, governance, and delivery in minutes, and get a recommended next step.",
    path: "/scorecard",
  },
  resources: {
    title: "Frameworks & Field Notes — Copper & Vine",
    description:
      "An owned library of operator frameworks and field notes: build vs buy vs fix, AI readiness, and governance for founders and institutions.",
    path: "/resources",
  },
  events: {
    title: "Operator Dinners & Working Sessions — Copper & Vine",
    description:
      "Technology executive dinners, operator working sessions, and office hours. Rooms worth being in for founders and operators.",
    path: "/events",
  },
  about: {
    title: "About Copper & Vine — Advisory Since 2003",
    description:
      "Copper & Vine is an executive technology advisory and engineering studio founded in 2003 by Rakia Finley. Senior judgment, on the record.",
    path: "/about",
  },
  refer: {
    title: "Refer Founders — Copper & Vine Partner Program",
    description:
      "Become a technology referral partner. Refer founders and operators to Copper & Vine and earn a rate that respects your network.",
    path: "/refer",
  },
  theTable: {
    title: "The Table — Private Operator Membership — Copper & Vine",
    description:
      "The Table is a private membership for operators: senior technology judgment, peer rooms, and working sessions.",
    path: "/the-table",
  },
};

// /for/:segment landing pages.
export const SEGMENT_SEO = {
  founders: {
    title: "Technology Advisory for Founders — Copper & Vine",
    description:
      "Fractional CTO and technology advisory for founders. Get the architecture, the build, and the funding story right.",
  },
  enterprises: {
    title: "Enterprise AI Governance & Readiness — Copper & Vine",
    description:
      "Enterprise AI governance and readiness. Documentation, decision rights, and compliance that hold up under board and regulatory scrutiny.",
  },
  entrepreneurs: {
    title: "Technology Validation for Early Founders — Copper & Vine",
    description:
      "MVP validation consulting for early founders. Define the customer, pressure-test the model, and get a roadmap before you build.",
  },
  nonprofits: {
    title: "Technology Advisory for Nonprofits — Copper & Vine",
    description:
      "Nonprofit technology consulting. Governance, continuity, and funder-ready reporting without adding a full-time executive to the budget.",
  },
  advisors: {
    title: "Refer Founders — Copper & Vine Partner Program",
    description:
      "Technology referral partner program. Refer founders and operators to Copper & Vine and earn a rate that respects your network.",
  },
};

// Reusable JSON-LD builders -------------------------------------------------
export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: SITE_URL + it.path,
  })),
});

export const serviceLd = ({ name, description, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  provider: { "@type": "Organization", name: ORG_NAME, url: SITE_URL },
  areaServed: ["United States", "United Kingdom", "Switzerland", "Ghana", "Nigeria", "Mexico"],
  ...(path ? { url: SITE_URL + path } : {}),
});

export const faqLd = (qa) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: qa.map((x) => ({
    "@type": "Question",
    name: x.q,
    acceptedAnswer: { "@type": "Answer", text: x.a },
  })),
});
